import logo1 from "./assets/logo-devlens.svg";
import logo2 from "./assets/logo-style-spy.svg";
import logo3 from "./assets/logo-speed-boost.svg";
import logo4 from "./assets/logo-json-wizard.svg";
import logo5 from "./assets/logo-tab-master-pro.svg";
import logo6 from "./assets/logo-viewport-buddy.svg";
import logo7 from "./assets/logo-markup-notes.svg";
import logo8 from "./assets/logo-grid-guides.svg";
import logo9 from "./assets/logo-palette-picker.svg";
import logo10 from "./assets/logo-link-checker.svg";
import logo11 from "./assets/logo-dom-snapshot.svg";
import logo12 from "./assets/logo-console-plus.svg";

const data = [
  {
    id: 1,
    logo: logo1,
    name: "DevLens",
    description:
      "Quickly inspect page layouts and visualize element boundaries.",
    isActive: true,
  },
  {
    id: 2,
    logo: logo2,
    name: "StyleSpy",
    description: "Instantly analyze and copy CSS from any webpage element.",
    isActive: true,
  },
  {
    id: 3,
    logo: logo3,
    name: "SpeedBoost",
    description: "Optimizes browser resource usage to accelerate page loading.",
    isActive: false,
  },
  {
    id: 4,
    logo: logo4,
    name: "JSONWizard",
    description:
      "Formats, validates, and prettifies JSON responses in-browser.",
    isActive: true,
  },
  {
    id: 5,
    logo: logo5,
    name: "TabMaster Pro",
    description: "Organizes browser tabs into groups and sessions.",
    isActive: true,
  },
  {
    id: 6,
    logo: logo6,
    name: "ViewportBuddy",
    description:
      "Simulates various screen resolutions directly within the browser.",
    isActive: false,
  },
  {
    id: 7,
    logo: logo7,
    name: "Markup Notes",
    description:
      "Enables annotation and notes directly onto webpages for collaborative debugging.",
    isActive: true,
  },
  {
    id: 8,
    logo: logo8,
    name: "GridGuides",
    description:
      "Overlay customizable grids and alignment guides on any webpage.",
    isActive: false,
  },
  {
    id: 9,
    logo: logo9,
    name: "Palette Picker",
    description: "Instantly extracts color palettes from any webpage.",
    isActive: true,
  },
  {
    id: 10,
    logo: logo10,
    name: "LinkChecker",
    description: "Scans and highlights broken links on any page.",
    isActive: true,
  },
  {
    id: 11,
    logo: logo11,
    name: "DOM Snapshot",
    description: "Capture and export DOM structures quickly.",
    isActive: false,
  },
  {
    id: 12,
    logo: logo12,
    name: "ConsolePlus",
    description:
      "Enhanced developer console with advanced filtering and logging.",
    isActive: true,
  },
];

export default data;
